import LabelledCard from './LabelledCard';
export default LabelledCard;
